export class PlayerLocomotionSmooth {

    constructor() {
    }
}